export default __webpack_public_path__ + "static/media/dponet-logo-white.9b545ea6.svg";